import React from "react";
import "./Footer.css";
import { Fade } from "../reveal/Fade";
/* eslint-disable jsx-a11y/accessible-emoji */

export default function Footer(props) {
   const currentYear = new Date().getFullYear();
  return (
    <div className="footer-div" style={{ textAlign: "center", padding: "1rem" }}>
      <Fade>
        <p className="footer-text" style={{ color: props.theme.secondaryText, fontWeight: 500 }}>
          © {currentYear} Ilo Nomena. Tous droits réservés. - MIT License
        </p>
        <p className="footer-subtext" style={{ color: props.theme.secondaryText, fontSize: "0.85rem" }}>
          Développement propre et projets à impact ✨
        </p>
      </Fade>
    </div>
  );
}
